import { CompanyAdminzoneState } from "@/types/store/adminzone";
import { CompanyData } from "@/types";

export const state: CompanyAdminzoneState = {
  companies: [] as Array<CompanyData>
}
